/* ============================================
   ENDURA SHOPIFY THEME - Custom JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ---- Header scroll effect ----
  const header = document.querySelector('.endura-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 20) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }

  // ---- Mobile nav toggle ----
  const mobileToggle = document.querySelector('.endura-header__mobile-toggle');
  const mobileNav = document.querySelector('.endura-mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
      const isOpen = mobileNav.classList.contains('open');
      mobileToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  // Hero carousel is handled inline in endura-hero.liquid

  // ---- Product selector flavour picker ----
  const flavourPickerBtns = document.querySelectorAll('.endura-products__flavour-btn');
  if (flavourPickerBtns.length) {
    flavourPickerBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        flavourPickerBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        const flavour = btn.getAttribute('data-flavour');
        const detailImg = document.querySelector('.endura-products__detail-image img');
        const detailName = document.querySelector('.endura-products__detail-name');
        const imgSrc = btn.getAttribute('data-img');

        if (detailImg && imgSrc) {
          detailImg.style.opacity = '0';
          setTimeout(function () {
            detailImg.src = imgSrc;
            detailImg.style.opacity = '1';
          }, 200);
          detailImg.style.transition = 'opacity 0.3s ease';
        }

        if (detailName && flavour) {
          detailName.textContent = flavour;
        }
      });
    });
  }

  // ---- Strength selector ----
  const strengthBtns = document.querySelectorAll('.endura-products__strength-btn');
  if (strengthBtns.length) {
    strengthBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        strengthBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  }

  // ---- Ingredients accordion ----
  const ingredients = document.querySelectorAll('.endura-ingredient');
  if (ingredients.length) {
    ingredients.forEach(function (item) {
      item.addEventListener('click', function () {
        const isActive = item.classList.contains('active');
        ingredients.forEach(function (i) { i.classList.remove('active'); });
        if (!isActive) {
          item.classList.add('active');
        }
      });
    });
    // Open first by default
    if (ingredients[0]) {
      ingredients[0].classList.add('active');
    }
  }

  // ---- FAQ accordion ----
  const faqItems = document.querySelectorAll('.endura-faq__item');
  if (faqItems.length) {
    faqItems.forEach(function (item) {
      const question = item.querySelector('.endura-faq__question');
      if (question) {
        question.addEventListener('click', function () {
          const isOpen = item.classList.contains('open');
          faqItems.forEach(function (i) { i.classList.remove('open'); });
          if (!isOpen) {
            item.classList.add('open');
          }
        });
      }
    });
    // Open first FAQ by default
    if (faqItems[0]) {
      faqItems[0].classList.add('open');
    }
  }

  // ---- Newsletter form ----
  const subscribeForm = document.querySelector('.endura-footer__subscribe-form');
  if (subscribeForm) {
    subscribeForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = subscribeForm.querySelector('.endura-footer__subscribe-input');
      if (input && input.value) {
        const btn = subscribeForm.querySelector('.endura-footer__subscribe-btn');
        if (btn) {
          btn.style.background = '#4CAF50';
          setTimeout(function () {
            btn.style.background = '';
          }, 2000);
        }
        input.value = '';
        input.placeholder = 'Thank you for subscribing!';
        setTimeout(function () {
          input.placeholder = 'Enter your email';
        }, 3000);
      }
    });
  }

  // ---- Smooth scroll for anchor links ----
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Close mobile nav if open
        if (mobileNav) {
          mobileNav.classList.remove('open');
        }
      }
    });
  });

  // ---- Intersection Observer for animations ----
  const animateEls = document.querySelectorAll('.endura-mission__feature, .endura-testimonial-card, .endura-faq__item, .endura-ingredient');
  if ('IntersectionObserver' in window && animateEls.length) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    animateEls.forEach(function (el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.5s ease ' + (i * 0.08) + 's, transform 0.5s ease ' + (i * 0.08) + 's';
      observer.observe(el);
    });
  }

});

// ---- Cart Drawer ----
(function () {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-drawer-overlay');
  const closeBtn = document.getElementById('cart-drawer-close');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');

  function openCartDrawer() {
    if (drawer) {
      drawer.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCartDrawer() {
    if (drawer) {
      drawer.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }
  }

  if (cartTriggers.length) {
    cartTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    });
  }

  if (overlay) {
    overlay.addEventListener('click', closeCartDrawer);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeCartDrawer);
  }

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && !drawer.hasAttribute('hidden')) {
      closeCartDrawer();
    }
  });
}());
